package org.example.site_web.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.MixBlendMode
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.functions.max
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.example.site_web.HeadlineTextStyle
import org.example.site_web.SubheadlineTextStyle
import org.example.site_web.aiPalette
import org.example.site_web.components.layouts.PageLayoutData
import org.example.site_web.components.widgets.AnimEngrenage
import org.example.site_web.components.widgets.AnimFactory
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Picture
import kotlin.math.sin


// Container that has a tagline and grid on desktop, and just the tagline on mobile
val HeroContainerStyle = CssStyle {

    base { Modifier.fillMaxWidth().gap(2.cssRem) }
    Breakpoint.MD { Modifier.margin { top(3.vh) } }
}

// A demo grid that appears on the homepage because it looks good
val HomeGridStyle = CssStyle.base {
    Modifier
        .gap(0.5.cssRem)
        .width(70.cssRem)
        .height(30.cssRem)
}

// A demo grid that appears on the homepage because it looks good
val AnimGridStyle = CssStyle.base {
    Modifier
        .gap(3.0.cssRem)
        .width(60.cssRem)
        .height(20.cssRem)

}

private val GridCellColorVar by StyleVariable<Color>()
val HomeGridCellStyle = CssStyle.base {
    Modifier
        .backgroundColor(GridCellColorVar.value())
        .boxShadow(blurRadius = 0.6.cssRem, color = GridCellColorVar.value())
        .borderRadius(1.cssRem)
}


@InitRoute
fun initPreviousHomePage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Home"))
}

@Composable
private fun Presentation() {
    Box {
        Box(Modifier.zIndex(1)) {
            Column(Modifier.gap(2.cssRem)
                .padding {
                    left(10.vw)
                    top(10.vw)
                }) {

                Div(HeadlineTextStyle.toAttrs()) {
                    SpanText(
                        "Notre site est en construction. \r\nVous trouverez très prochainement plus de détails sur nos offres. "
                    )
                }

                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText("Pour toute information ")
                    SpanText(
                        "contact@accelarge.com",
                        modifier = Modifier
                            .fontWeight(FontWeight.Bold)
                    )
                }

            }
        }

        var frame by remember { mutableStateOf(0.0) }

        LaunchedEffect(true) {
            // This coroutine will be launched when MyComposable is initially composed
            while(true)
            {
                if(frame > 300.0){
                    frame = 0.0
                }
                else
                {
                    frame += 1.0
                }
                delay(100)
            }
        }

        val framep = 50.0*(1.0+sin(2*3.1415*((frame - 100.0*(frame/100.0).toInt())-25)/100.0))

        val red = aiPalette.darkBackColor.toRgb().red + (framep*(255.0-aiPalette.darkBackColor.toRgb().red)/100.0).toInt()
        val green =aiPalette.darkBackColor.toRgb().green + (framep*(255.0-aiPalette.darkBackColor.toRgb().green)/100.0).toInt()
        val blue =aiPalette.darkBackColor.toRgb().blue + (framep*(255.0-aiPalette.darkBackColor.toRgb().blue)/100.0).toInt()

        Box(Modifier
        .backgroundColor(Color.rgb(red, green, blue)).overflow(Overflow.Clip))
         {
            val srcPic = when{
                (frame/100.0).toInt() == 0 -> "3_hero.jpg"
                (frame/100.0).toInt() == 1 -> "1_hero.jpg"
                else -> "2_hero.jpg"
            }
             Picture {  }
            Img(src = "assets/heropics/$srcPic",
                alt="pcb_factory",
                attrs = Modifier.width(max(100.vw,768.px))
                    .mixBlendMode(MixBlendMode.Darken).toAttrs())
        }
    }
}

@Composable
private fun BuildAnimation() {
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier.width(50.vw), contentAlignment = Alignment.CenterStart
    ) {
        var factoryIsRunning by remember { mutableStateOf(false) }
        val animBoxModifier = Modifier.aspectRatio(1f)
            .backgroundColor(sitePalette.brand.primary)
            .boxShadow(blurRadius = 0.6.cssRem, color = Colors.White)
            .borderRadius(0.5.cssRem)
            .border(2.px, LineStyle.Solid, sitePalette.brand.primary)
            .overflow(Overflow.Hidden)
            .fillMaxSize()
            .maxHeight(250.px)
            .maxWidth(250.px)
        Div(
            animBoxModifier
            .onMouseEnter { factoryIsRunning = true }
            .onMouseLeave { factoryIsRunning = false }.toAttrs()
        )
        {
            var frameCntrLoc by remember { mutableStateOf(0) }
            LaunchedEffect(key1 = factoryIsRunning, key2 = null) {
                while (true) {
                    frameCntrLoc += 1
                    frameCntrLoc = frameCntrLoc % 100
                    delay(35)
                }
            }
            AnimFactory(frame = frameCntrLoc.toDouble())
        }
    }
}

@Composable
private fun RotateAnimation(){
    Box(
    modifier = Modifier.width(50.vw), contentAlignment = Alignment.CenterStart
    ) {
        var factoryIsRunning by remember { mutableStateOf(false) }
        val animBoxModifier = Modifier.aspectRatio(1f)
            .backgroundColor(aiPalette.darkBackColor)
            .overflow(Overflow.Hidden)
            .fillMaxSize()
            .maxHeight(250.px)
            .maxWidth(250.px)
        Div()
        {
            var frameCntrLoc by remember { mutableStateOf(0) }
            LaunchedEffect(key1 = factoryIsRunning, key2 = null) {
                while (true) {
                    frameCntrLoc += 1
                    frameCntrLoc = frameCntrLoc % 360
                    delay(35)
                }
            }
            AnimEngrenage(frame = frameCntrLoc.toDouble())
        }
    }
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun PreviousHomePage() {

    Row(HeroContainerStyle.toModifier().
        displayIfAtLeast(Breakpoint.MD)) {
        Presentation()
        //RotateAnimation()
    }

    Column(HeroContainerStyle.toModifier().
    displayUntil(Breakpoint.MD)) {
        Presentation()
    }
}
